import actionTypes from '../constants/action-types';

const hide = () => ({
  type: actionTypes.HIDE,
});

export default hide;
